/**
 * Display helpers specific to this portal.
 *
 * Anything generic - dates, byte sizes, numbers - comes from `@/shared/lib`
 * instead. What lives here is the vocabulary of an operations console: the
 * enums the server returns, turned into something readable and consistently
 * coloured across five tables.
 */

/** `smoke_testing` reads badly in a table; `Smoke testing` does not. */
export function humanise(value: string): string {
  const spaced = value.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export const stageLabel = humanise;

/*
 * The four `*Tone` helpers that used to live here are gone.
 *
 * They mapped stages, log levels, severities and issue statuses onto shadcn's
 * four Badge variants - a second, competing colour map beside the design's own,
 * which meant "failed" could be one red in this portal and a different one in
 * the admin console. `StatusPill` in shared now owns that vocabulary for every
 * portal, so a status word looks the same wherever it appears.
 *
 * Add a status word to the map in `shared/ui/status-pill.tsx` rather than
 * reintroducing a local one here.
 */

/**
 * `fileSizeBytes` arrives as a string.
 *
 * The column is a BigInt server-side, and JSON has no integer type wide enough
 * to carry one safely - so the contract sends it as a string on purpose.
 * Parsing it back to a Number for display is fine; an installer large enough to
 * lose precision at 2^53 bytes is not a problem this portal will have.
 */
export function parseByteSize(value: string | number): number {
  return typeof value === 'number' ? value : Number.parseInt(value, 10);
}
